<form [formGroup]="form" autocomplete="off" class="form-horizontal">

  <!-- ZAHL ARBEITNEHMER -->
  <div class="mb-5x">

    <h3>{{ arbeitnehmerTitel | translate }}</h3>

    <div *ngIf="this.showHinweis" class="mb-3x mt-2x">
      <common-ui-card [message]="'COMMON_UI.FRAGEBOGEN.LOHNSTEUER.HINWEIS' | translate" type="info"></common-ui-card>
    </div>

    <div class="form-row">
      <label class="col-sm-8 col-form-label" for="arbeitnehmer">
        {{ this.zahlGesamt }}
      </label>
      <div class="col-sm-4">
        <input class="form-control" datevMessagePath="arbeitnehmer{{objectId}}" formControlName="arbeitnehmer" id="arbeitnehmer"
               type="text" numeric utilsCheckValidity utilsControlState
               utilsMarkRequired
               utilsValidationMessage/>
      </div>
    </div>

    <div *ngIf="+data.arbeitnehmer>0">
      <div class="form-row">
        <label class="col-sm-7 offset-sm-1 col-form-label" for="familienangehoerige">
          {{ this.zahlFamilie }}
        </label>
        <div class="col-sm-4">
          <input [checkAdditionalControls]="['arbeitnehmer']" class="form-control"
                 datevMessagePath="familienangehoerige{{objectId}}" formControlName="familienangehoerige"
                 id="familienangehoerige" type="text" numeric
                 utilsCheckValidity utilsControlState
                 utilsMarkRequired
                 utilsValidationMessage/>
        </div>
      </div>

      <div class="form-row">
        <label class="col-sm-7 offset-sm-1 col-form-label" for="geringfuegigBeschaeftigte">
          {{ this.zahlGeringfuegig }}
        </label>
        <div class="col-sm-4">
          <input [checkAdditionalControls]="['arbeitnehmer']" class="form-control"
                 datevMessagePath="geringfuegigBeschaeftigte{{objectId}}" formControlName="geringfuegigBeschaeftigte"
                 id="geringfuegigBeschaeftigte" type="text" numeric
                 utilsCheckValidity utilsControlState
                 utilsMarkRequired
                 utilsValidationMessage/>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="+data.arbeitnehmer>0">

    <!-- BEGINN DER LOHNZAHLUNGEN -->
    <common-ui-beginn-lohnzahlungen [(data)]="data" [readonly]="readonly"></common-ui-beginn-lohnzahlungen>

    <!-- VORAUSSICHTLICHE LOHNSTEUER -->
    <common-ui-voraussichtliche-lohnsteuer [(data)]="data"
                                           [readonly]="readonly"></common-ui-voraussichtliche-lohnsteuer>

    <!-- LOHNSTEUERLICHE BETRIEBSSTÄTTE -->
    <common-ui-lohnsteuer-betriebsstaette [(data)]="data" [readonly]="readonly"></common-ui-lohnsteuer-betriebsstaette>

  </div>
</form>

<ng-template #datenUebernahmeBetriebstaette let-item="item">
  <h4 class="list-group-item-heading">{{item?.bezeichnung}}</h4>
  <p class="list-group-item-text">
    {{item?.inlandsadresse?.strasse}} {{item?.inlandsadresse?.hausnummer}} {{item?.inlandsadresse?.hausnummernzusatz}}
    <br *ngIf="item?.inlandsadresse?.adressergaenzung">{{item?.inlandsadresse?.adressergaenzung}}
    <br>{{item?.inlandsadresse?.postleitzahl}} {{item?.inlandsadresse?.ort}}</p>
</ng-template>
